/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { TimeUnit } from "../constant";
import { OptionTypeBase } from "./common";
import { UntaggedConditionRuleData } from "./rule";

export interface ISLAResponseNextRequest {
  responseNextDay?: string;
  responseNextTime?: string;
}

export interface ISLARequest {
  id?: string;
  name?: string;
  description?: string;
  type?: string;
  responseNext?: ISLAResponseNextRequest;
  responseTime?: number;
  response?: {
    responseTime?: number;
    responseNext?: ISLAResponseNextRequest;
  };
}

export interface ISLAResponse {
  id?: string;
  name?: string;
  description?: string;
  type?: string;
  responseTime?: number;
  responseNext?: ISLAResponseNextRequest;
  unitType?: string;
}

export interface ISLARuleRequest {
  name?: string;
  description?: string;
  slaId?: string;
  enabled?: boolean;
  timezone?: string;
  conditionRule?: UntaggedConditionRuleData | null;
}

export interface ISLARuleResponse {
  id?: string;
  name?: string;
  description?: string;
  sla?: OptionTypeBase;
  enabled?: boolean;
  timezone?: string;
  conditionRule?: UntaggedConditionRuleData | null;
}

export const defaultSLARule: Readonly<ISLARuleResponse> = {
  id: "",
  name: "",
  description: "",
  sla: null,
  enabled: true,
  timezone: "",
  conditionRule: null,
};

export const defaultSLA: Readonly<ISLAResponse> = {
  id: "",
  name: "",
  description: "",
  type: "",
  unitType: TimeUnit.MINUTES,
  responseNext: {
    responseNextDay: "DAY",
    responseNextTime: "",
  },
  responseTime: 1,
};
